<template>
    <Teleport to="body">
        <Transition name="modal-fade">
            <div class="modal-wrapper" @click.self="handleCloseModal" v-if="modalState?.component">
                <component :is="modalState.component" v-bind="modalState.props" />
            </div>
        </Transition>
    </Teleport>
</template>

<script lang="ts">
import { mapGetters, mapActions } from 'vuex'; // Import useStore from vuex

export default {
    name: 'ModalWindow',
    computed: {
        ...mapActions(['closeModal']),
        ...mapGetters(['modalState']),
    },
    methods: {
        async handleCloseModal() {
            await this.$store.dispatch('closeModal');
        },
    },
};
</script>
